import Crud from '../views/Contato/Crud'
import Entity from '../views/Contato/Add'

let routes = {
    path: '/contatos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/contatos/edit/:id?',
            name: 'EditContato',
            component: Entity
        },
        {
            path: '/contatos',
            name: 'list-contatos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Contatos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
